module.exports = __webpack_public_path__ + "/build/web/svg/ic-account-box-black-24-px.298ee430a93fa0da3164c6c8620d7af2.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/ic-account-box-black-24-px.svg
// module id = 219
// module chunks = 13